import { ABaseModel } from '../abstracts/ABaseModel.js';
import { Image } from './Image.js';
import { PaginationResult, ListResult } from './List.js';
import {
  IEvent,
  IEventPaginationResult,
  IEventRsvp,
  IEventRsvpPaginationResult,
  IEventRsvpListResult,
} from '../interfaces/Event.js';

/**
 * Event
 */
class Event extends ABaseModel implements IEvent {
  id: number;
  status: number;
  type: number;
  name: string;
  slug: string;
  externalUrl: string;
  showcase: boolean;
  ranking: number;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  description: string;
  venueName: string;
  venueAddress: string;
  venueCity: string;
  venuePostCode: string;
  venueCountryCode: string;
  venuePhone: string;
  rsvpType: number;
  rsvpSend: number;
  rsvpShow: boolean;
  isFinished: boolean;
  canUpdate: boolean;
  canActivate: boolean;
  canCancel: boolean;
  canRsvp: boolean;
  visibility: string;
  ticketAmount: string;
  ticketCurrency: string;
  ticketMaxNumber: string;
  creatorType: string;
  creatorId: number;
  creatorRole: string;
  creatorName: string;
  artistId: number;
  artistAlias: string;
  artistName: string;
  images: Array<Image>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * EventPaginationResult
 */
class EventPaginationResult extends PaginationResult implements IEventPaginationResult {
  declare items: Array<Event>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * EventRsvp
 */
class EventRsvp extends ABaseModel implements IEventRsvp {
  id: number;
  status: number;
  notify: boolean;
  eventId: number;
  userId: number;
  userStatus: number;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userLocale: string;
  userAvatars: Array<Image>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * EventRsvpPaginationResult
 */
class EventRsvpPaginationResult extends PaginationResult implements IEventRsvpPaginationResult {
  declare items: Array<EventRsvp>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * EventRsvpListResult
 */
class EventRsvpListResult extends ListResult implements IEventRsvpListResult {
  declare items: Array<EventRsvp>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

export { Event, EventPaginationResult, EventRsvp, EventRsvpPaginationResult, EventRsvpListResult };
